module.exports = __webpack_public_path__ + "img/campagin-04.b49d839f.svg";